var render = function render(_c, _vm) {
  return _c("div", { staticClass: "no-info text-center mt-4" }, [
    _c("div", { staticClass: "row" }, [
      _vm._m(0),
      _c("div", { staticClass: "col-12 mt-2" }, [
        _c("span", { staticClass: "no-info__text" }, [
          _vm._v(
            " " +
              _vm._s(_vm.props.text || "No hay información disponible.") +
              " "
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function(_c, _vm) {
    return _c("div", { staticClass: "col-12" }, [
      _c("em", { staticClass: "fal fa-folder-open no-info__icon" })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }